import React, { useEffect } from 'react';

import { Downgraded, useState } from '@hookstate/core';
import CustomTabs from '../customTabs/customTabs';
import UserCheckList from './userCheckList';
// import Helper from '../../utility/helper';
// import ApiHelper from '../../utility/ApiHelper';
// import APIURLConstants from '../../config/config';

const UserList = (props) =>
{
    const tabValue = useState(0);
    const allUsers = useState([]);
    const collectionTabs = useState([
        {
            label: 'All Users',
            value: 0,
            component: UserCheckList,
            data: [],
        },
        {
            label: 'Individuals',
            value: 1,
            component: UserCheckList,
            data: [],
        },
        {
            label: 'Groups',
            value: 2,
            component: UserCheckList,
            data: [],
        },
    ]);

    useEffect(() =>
    {
        // console.log(props,props.skipEventParticipants,"allUsers.get()",allUsers.get(),"props.users && allUsers.get() && allUsers.get().length == 0",props.users && allUsers.get() && allUsers.get().length == 0);
        if (props.users && props.skipEventParticipants )
        {
            // console.log("props.skipEventParticipants",props.skipEventParticipants, props.skipEventParticipants &&
            // props.skipEventParticipants.length > 0);
            let newUsers = props.users;
            if (newUsers)
            {
                if (
                    props.skipEventParticipants &&
                    props.skipEventParticipants.length > 0
                )
                {
                    // console.log("props.skipEventParticipants",props.skipEventParticipants);
                    const eventParticipants = props.skipEventParticipants;
                    newUsers = newUsers.filter(
                        (x) =>
                            !eventParticipants.filter((y) => y === x.userID)
                                .length
                    );
                }
                if (
                    collectionTabs.attach(Downgraded).get()[0].data
                        .length == 0
                )
                {
                    collectionTabs
                        .attach(Downgraded)
                        .get()
                        .map((item, index) =>
                        {
                            if (index == 0)
                            {
                                collectionTabs[index].set({
                                    ...item,
                                    data: newUsers,
                                });
                            }
                        });
                }
                allUsers.set(newUsers);
                // console.log(
                //     'collectionTabs : ',
                //     collectionTabs.attach(Downgraded).get()
                // );
            }
        }

        if (props.search)
        {
            let newCollectionTabs = [...allUsers.attach(Downgraded).get()];
            let newUserData = newCollectionTabs.filter(user =>
            {
                return user.name.toLowerCase().indexOf(props.search.toLowerCase().trim()) > -1 ||
                (user.email && user.email !== null && user.email
                    .toLowerCase()
                    .indexOf(props.search.toLowerCase().trim()) > -1) ||
                    (user.userType && user.userType !== null && user.userType
                        .toLowerCase()
                        .indexOf(props.search.toLowerCase().trim()) > -1) ||
                    (user.userTags && user.userTags !== null && user.userTags
                        .toLowerCase()
                        .indexOf(props.search.toLowerCase().trim()) > -1)
            });
            collectionTabs[0].data.set(newUserData);
        }
        else
        {
            collectionTabs[0].data.set(allUsers.attach(Downgraded).get());
        }
    }, [props]);
    const handleChange = (value) =>
    {
        tabValue.set(value);
    };
    return (
        <CustomTabs
            value={tabValue.get()}
            handleChange={handleChange}
            data={collectionTabs.attach(Downgraded).get()}
            fixedTabs={true}
            centered
            variant="fullWidth"
            checkUsers={props.checkUsers}
            selectedUsers={props.selectedUsers}
        />
    );
};
export default UserList;
